import { interval } from "rxjs";
import { Component, OnInit, ViewChild, ElementRef, Input, DoCheck, OnDestroy } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { AppConfig } from "@app/core/Utilities/app-config.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { Router } from "@angular/router";
import { environment as env } from "@env/environment";
import { ApiService } from "@app/core";
import { ChatService, SignalRService } from "@app/core/services/chat.service";
import { NotificationService } from '@app/core/services/notification.service';
import { MessageCenterService } from '@app/core/services/message-center.service';
import { ResultStatus } from '@app/core/models/result-status';
import { WhatIsNewComponent } from '@app/modules/home/pages/what-is-new/what-is-new.component';
import { HomeService } from '@app/core/services/home.service';
import { HelperService } from '@app/core/services/helper.service';

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, DoCheck, OnDestroy {
  // public isLoggedIn:boolean = false;
  public showHeader: boolean = false;
  @Input() showHeaderSection: boolean = false;
  public ssoHiddenFormData: FormData = null;
  public userName: string = "";
  public isAdmin: boolean = false;
  modalRef: BsModalRef;

  public showTestingSiteAlert: boolean = false;

  @ViewChild("notifyForMLSnumber") notifyForMLSnumber: ElementRef;

  constructor(
    public authService: AuthenticationService,
    private cookieService: CookieService,
    public appConfig: AppConfig,
    private modalService: BsModalService,
    private router: Router,
    private apiService: ApiService,
    private chatService: ChatService,
    public signalRService: SignalRService,
    private messageCenterService: MessageCenterService,
    private notificationService: NotificationService,
    private homeService: HomeService,
    private helperService: HelperService
  ) {
    if (this.authService.getAccountInfo()) {
      const response = this.authService.getAccountInfo();
      this.authService.setMemnerID(response.idTokenClaims.extension_MemberID);
      this.setUserInfo();
    }
  }

  ngDoCheck() {
    this.showTestingSiteAlert = this.router.url != "/" && env.envName == "BETA";
  }

  ngOnInit() {
    this.showTestingSiteAlert = this.router.url != "/" && env.envName == "BETA";
    this.showHeader = false;

    this.setUserInfo();
    // Make call on some interval to update user is active.
    interval(this.appConfig.updateUserActiveIntervalMS).subscribe((x) => {
      if (this.authService.isUserLoggedIn()) {
        this.updateUserActive();
      }
    });
  }

  setUserInfo() {
    if (this.authService.isUserLoggedIn()) {
      setTimeout(() => {
        this.authService
          .getMemberDetails(this.authService.getMemberID())
          .subscribe(
            (response: any) => {
              this.authService.setUserInformation(response);
              this.setLoginUser();
              this.getActiveChatList();  
              this.chatService.setuserArchiveChat();
              this.notificationService.updateNotificationCount();
              this.messageCenterService.updateInboxCount();
              if (this.appConfig.SharedComponent.isWhatIsNewVisible === true) {
                this.appConfig.SharedComponent.isWhatIsNewVisible = false;
                this.viewWhatsNewFeature();
              }
              if (this.authService.isAdmin()) {
                this.isAdmin = true;
                window.localStorage.setItem("isAdmin", "" + this.isAdmin + "");
              } else {
                this.isAdmin = false;
                window.localStorage.setItem("isAdmin", "" + this.isAdmin + "");
              }
              try {
                if (
                  this.authService.getUserInformation()["MLSNumber"] === false &&
                  !JSON.parse(window.localStorage.getItem("showMlsID"))
                ) {
                  if (
                    !window.location
                      .toString()
                      .includes("addUpdateMLSnumber") &&
                    !window.location.href.includes("MLSnumber")
                  ) {
                    this.modalRef = this.modalService.show(
                      this.notifyForMLSnumber
                    );
                    window.localStorage.setItem("showMlsID", "true");
                    // Get the existing data and set MLSNumber to false to call only one time
                    // var existing = localStorage.getItem("agentBasicDetails");
                    // existing = existing ? JSON.parse(existing) : {};
                    // existing["MLSNumber"] = true;
                    // console.log(JSON.stringify(existing));
                    // window.localStorage.setItem("agentBasicDetails", JSON.stringify(existing));
                  }
                }
              } catch (err) { }

              this.appConfig.SharedComponent.userLoggedIn = this.authService.isUserLoggedIn();
              this.appConfig.SharedComponent.userName =
                this.authService.getUserInformation()["FirstName"] +
                " " +
                this.authService.getUserInformation()["LastName"];
              this.showHeader = true;
              this.startConnection();
            },
            (error: any) => {
              this.appConfig.SharedComponent.userLoggedIn = this.authService.isUserLoggedIn();
              this.setLoginUser();
              this.startConnection();
              this.getActiveChatList();
              this.notificationService.updateNotificationCount();
              this.messageCenterService.updateInboxCount();
              this.appConfig.SharedComponent.userName =
                this.authService.getUserInformation()["FirstName"] +
                " " +
                this.authService.getUserInformation()["LastName"];
              this.showHeader = true;
              window.localStorage.setItem("showMlsID", "false");
            }
          );
      }, 1000);
    } else {
      this.showHeader = true;
      this.cookieService.deleteAll("/");
      window.localStorage.removeItem("agentBasicDetails");
      window.localStorage.removeItem("isAdmin");
      window.localStorage.removeItem("MemberID");
      this.appConfig.SharedComponent.userLoggedIn = false;
      this.appConfig.SharedComponent.loggedInUserInfo = null;
      this.appConfig.SharedComponent.notificationCount = 0;
      this.appConfig.SharedComponent.inboxCount = 0;
      this.chatService.SharedChatComponent.userActiveChat = [];
      this.chatService.SharedChatComponent.userArchiveChat = [];
      this.appConfig.SharedComponent.isWhatIsNewVisible = false;
      this.signalRService.stopConnection();
    }
  }

  updateUserActive() {
    this.authService.updateUserLastLoggedIn().subscribe(
      (res) => { },
      (error) => { }
    );
  }

  setLoginUser() {
    this.apiService
      .get(this.appConfig.GetUrl("getLoginUser"))
      .subscribe((result: any) => {
        this.appConfig.SharedComponent.loggedInUserInfo = result;
      });
  }

  getActiveChatList() {
    this.chatService.getActiveUsersChat();
  }

  viewWhatsNewFeature() {
    this.homeService.getSystemWhatIsNewFeatureList().subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        if (!this.router.url.includes("YOURPROFILE") && !this.helperService.isUndefinedOrNullOrEmpty(result.Data)) {
          this.modalService.show(WhatIsNewComponent, { backdrop: "static", class: 'modal-md whatNew-modal' });
        }
      }
    });
  }

  startConnection() {
    this.signalRService.startConnection(+this.authService.getUserInformation()["ID"]);
  }

  ngOnDestroy() {
  }
}